import styled, { css } from "styled-components";

import { ReactComponent as BamLogoSvg } from "assets/logo-bam.svg";
import STANDARDDEFAULTSRC from "assets/logo-tsl.svg";
import { ReactComponent as PlaySvg } from "assets/play-icon.svg";
import { ReactComponent as PlayNextSvg } from "assets/play-next-icon.svg";
import { ReactComponent as PlaySvgBam } from "assets/play-icon-bam.svg";
import { ReactComponent as PlayNextSvgBam } from "assets/play-next-icon-bam.svg";
import buildLogo from "components/b2b/Logo";
import { showBamOnlineFeature } from "services/helpers/featureToggle";
import ColormapInterface from "shared-types/colormapinterface";
import { colorFilterUsage, fontWeight, letterSpacing } from "stylesheetB2b";
import { getSpacing } from "stylesheetB2c";
import { ALLEXTENSIONS, getLogoModel, STANDARDLOGOKEY } from "types/logo/logo";

const logoModel = getLogoModel(
	STANDARDLOGOKEY,
	ALLEXTENSIONS,
	STANDARDDEFAULTSRC,
);
const TslLogoImg = buildLogo(logoModel);

const LOGO_WIDTH_IN_PERCENT = 15;
const B2B_SONG_INFO_CONTAINER_PADDING_IN_PERCENT = 3.9;
const SONG_DETAILS_WIDTH_IN_PERCENT = 22;
export const SONG_DETAILS_FONT_SIZING_FACTOR = 1 / 36;
const SONG_DETAILS_LINE_HEIGHT_RATIO = 1.1;
const PLAY_AND_PLAY_NEXT_ICONS_WIDTH_IN_PERCENT = 16;
const PLAY_AND_PLAY_NEXT_ICONS_RIGHT_MARGIN_IN_PERCENT = 9;

export const BackgroundContainer = styled.div<{ visible: boolean }>`
  display: block;
  position: absolute;
  inset: 0;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
`;
BackgroundContainer.displayName = "BackgroundContainer";

export const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
`;
BackgroundImage.displayName = "BackgroundImage";

export const BamLogo = styled.img`
  position: absolute;
  left: 50%;
  bottom: 0%;
  width: ${LOGO_WIDTH_IN_PERCENT}%;
  transform: translate(-50%);
  ${
		showBamOnlineFeature() &&
		css`
    padding: ${getSpacing(2)};
  `
	}
`;
BamLogo.displayName = "BamLogo";

export const B2bSongInfoContainer = styled.div<{
	songDetailsFontSizeInPx: number;
	colors: ColormapInterface;
}>`
  position: absolute;
  left: 0%;
  bottom: 0%;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${B2B_SONG_INFO_CONTAINER_PADDING_IN_PERCENT}%;
  color: ${({ colors }) => colors.b2bSongInfos};
  ${({ songDetailsFontSizeInPx }) => css`
    /* This is necessary to avoid letters to overflow vertically */
    line-height: ${songDetailsFontSizeInPx * SONG_DETAILS_LINE_HEIGHT_RATIO}px;
    font-size: ${songDetailsFontSizeInPx}px;
  `}
  /* Letter spacing is zero, so it isn't affected by videoAreaHeight */
  letter-spacing: ${letterSpacing.small};
  white-space: nowrap;
`;
B2bSongInfoContainer.displayName = "B2bSongInfoContainer";

export const SongDetailsContainer = styled.div<{ right?: boolean }>`
  width: ${SONG_DETAILS_WIDTH_IN_PERCENT}%;
  display: flex;
  align-items: center;
  justify-content: ${({ right }) => (right ? "flex-end" : "flex-start")};
`;
SongDetailsContainer.displayName = "SongDetailsContainer";

export const PlayIcon = styled(PlaySvg)`
  width: ${PLAY_AND_PLAY_NEXT_ICONS_WIDTH_IN_PERCENT}%;
  margin-right: ${PLAY_AND_PLAY_NEXT_ICONS_RIGHT_MARGIN_IN_PERCENT}%;
  flex-shrink: 0;
`;
PlayIcon.displayName = "PlayIcon";

export const PlayIconBam = styled(PlaySvgBam)`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  stroke: #E32084
`;
PlayIconBam.displayName = "PlayIconBam";

export const PlayNextIcon = styled(PlayNextSvg)`
  width: ${PLAY_AND_PLAY_NEXT_ICONS_WIDTH_IN_PERCENT}%;
  margin-left: ${PLAY_AND_PLAY_NEXT_ICONS_RIGHT_MARGIN_IN_PERCENT}%;
  flex-shrink: 0;
`;
PlayNextIcon.displayName = "PlayNextIcon";

export const PlayNextIconBam = styled(PlayNextSvgBam)`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
`;
PlayNextIconBam.displayName = "PlayNextIconBam";

export const SongDetails = styled.div`
  /*
    We override the min-width: auto property on flex elements
    to avoid the ContentArea to take the width of its children
    in case of overflow.
    This is needed to ellipse text.
  */
  min-width: 0;
`;
SongDetails.displayName = "SongDetails";

export const SongDetailsTitle = styled.div`
  display: block;
  text-transform: uppercase;
  font-weight: ${fontWeight.bold};
  text-overflow: ellipsis;
  overflow: hidden;
`;
SongDetailsTitle.displayName = "SongDetailsTitle";

export const SongDetailsArtistName = styled.div`
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
`;
SongDetailsArtistName.displayName = "SongDetailsArtistName";

export const SongDetailsSingerName = styled.div`
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  text-transform: capitalize;
`;
SongDetailsSingerName.displayName = "SongDetailsSingerName";

export const TslLogo = styled(TslLogoImg)`
  width: ${LOGO_WIDTH_IN_PERCENT}%;
  filter: ${colorFilterUsage.tslLogoInverted};
  pointer-events: none;
`;
TslLogo.displayName = "TslLogo";

export const BamLogoSmall = styled(BamLogoSvg)`
  width: ${LOGO_WIDTH_IN_PERCENT}%;
  pointer-events: none;
`;
